import React from "react";
import Button from "../controls/Button";
import "./Modal.scss";
import PropTypes from "prop-types";

const ModalForm = ({ modalInfo, children, closeModal }) => {
  const { isOpen, title } = modalInfo;
  
  return (
    <>
      {isOpen && (
        <div className="modal-container">
          <div className="container col-xl-6 col-lg-6 col-md-8 col-12">
              <div className="modal-header bg-white pt-3 pe-2 mx-auto">
                <h5 className="modal-title ps-3">{title}</h5>
                <Button className="btn-close pe-3" onClick={() => closeModal()} />
              </div>
              <div
                className="modal-body-form bg-white mx-auto"
              >
                {children}
              
            </div>
          </div>
        </div>
      )}
    </>
  );
};

ModalForm.propTypes = {
  modalInfo: PropTypes.object,
  children: PropTypes.object,
  closeModal: PropTypes.func,
};

export default ModalForm;
